import React from "react";

import { connect } from "react-redux";

import Button from "../Button/Button";
import type { MarginInterface } from "../utilities/interfaces";

export enum DocumentationType {
  Lucerna,
  Customer,
}

type DocumentationButtonProps = MarginInterface & {
  documentationUrl?: string;
  customerDocumentationUrl?: string;
  docRoute: string;
  type?: DocumentationType;
};

const DocumentationButton = ({
  documentationUrl,
  customerDocumentationUrl,
  docRoute,
  type = DocumentationType.Lucerna,
  m,
  mx,
  my,
  mt,
  mb,
  mr,
  ml,
}: DocumentationButtonProps) => {
  const docUrl =
    type === DocumentationType.Customer
      ? customerDocumentationUrl
      : documentationUrl;

  if (!docRoute || !docUrl) return null;

  return (
    <Button
      newTab
      small
      m={m}
      mx={mx}
      my={my}
      mt={mt}
      mb={mb}
      mr={mr}
      ml={ml}
      icon="fa-regular fa-circle-info"
      variant="neutralLink"
      tooltip="User Guide"
      url={`${docUrl.replace(/\/+$/, "")}/${docRoute.replace(/^\/+/, "")}`}
    />
  );
};

const mapStateToProps = (state: {
  main: {
    documentationUrl?: string;
    customerDocumentationUrl?: string;
  };
}) => {
  return {
    documentationUrl: state?.main?.documentationUrl,
    customerDocumentationUrl: state.main.customerDocumentationUrl,
  };
};

export default connect(mapStateToProps)(DocumentationButton);
